module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user1-5a8a97e45d37f1faf0e3d135d36d0107.jpg";